import { Component, OnInit, Inject } from '@angular/core';
import { InterpretationService } from '../../interpretation.service';
import { NotificationsService } from 'angular2-notifications';
import { Condition, UpdateConditionCommentModel } from '../../models/interpretation.model';
import { UserService } from '../../../../shared/services/user.service';
import { AdditionalObservationListViewModel } from '../../../../modules/inspection/models/create-inspection.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';



export enum CommentPopupRequestPageAndFunc {
  ObservationListCommentCreateInspection = 1,
  ObservationListCommentInterpretation = 2,
  AddConditionCommentInterpretation = 3,
  AddConditionCommentCreateInspection = 4,
  AddComponentCommentInterpretation = 5,
  AddComponentCommentCreateInspection = 6,
  EditingInspectionComponentComment = 7,
  EditingInspectionConditionComment = 8,
  EquipmentDetailComment= 9,
  IndicatorRightComment=10,
  EqualiserBarTypeComment=11,
  IndicatorLeftComment =12,
  ObservationCommentsInspection = 13
}



@Component({
  selector: 'condition-comment-modal',
  templateUrl: './condition-comment-modal.component.html',
  styleUrls: ['./condition-comment-modal.component.scss']
})


export class ConditionCommentModalComponent implements OnInit {
  private inspectionId: number;
  private condition: Condition;
  comment: string;
  savingComment = false;
  isInspector = false;
  isInterpreter = false;

  comingFrom: CommentPopupRequestPageAndFunc;
  isEditingDraft = false;
  inspectionDraftId: number;
  equipmentId: number;
  isCreateNewSP: boolean = false;
  additionalObservationList: AdditionalObservationListViewModel;
  constructor(private _dialogRef: MatDialogRef<ConditionCommentModalComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _interp: InterpretationService,
    private _notify: NotificationsService,
  private _user: UserService) { }

  ngOnInit() {
    this.checkPermissions();

    console.log("editInsoection___", this._data)
    this.inspectionId = this._data.inspectionId;
    this.comment = this._data.comment;
    this.condition = this._data.condition;
    this.isCreateNewSP = this._data.isCreateNewSP;
    this.comingFrom = this._data.comingFrom;
    if (this.comingFrom) {
      this.additionalObservationList = this._data.additionalObservation;
    }
    if (this.inspectionId === undefined) {
      this.isEditingDraft = true;
      this.inspectionDraftId = this._data.inspectionDraftId;
      this.equipmentId = this._data.equipmentId;
    }    else
      this.isEditingDraft = false;
  }

  checkPermissions() {
    this._user.getUserJobRoles().subscribe(
      jobRoles => {
        jobRoles.forEach(role => {
          switch (role.Name) {
            case 'Inspectors':
              this.isInspector = true;
              break;
            case 'Interpreters':
            case 'Super User':
            case 'Administrator':
              this.isInterpreter = true;
              this.isInspector = true;
              break;
              case 'Customer Admin':
                this.isInspector = true;
              this.isInterpreter = true;
                break;
          }
        });
      },
      error => {
        console.error(error);
        this._notify.error('Error', 'Unable to check your job roles. ');
      }
    );
  }

  updateComment(newComment: string) {
    this.savingComment = true;
    const com = new UpdateConditionCommentModel();
    com.Condition = this.condition;
    com.InspectionId = this.inspectionId;
    com.NewComment = this.comment;

    if (this.comingFrom) {
      switch (this.comingFrom) {
        case +CommentPopupRequestPageAndFunc.ObservationListCommentCreateInspection:
          if(this.isCreateNewSP){
            this.successfulSaved('Saved', 'Additional Observation Comment Successfully Saved');
          }else {
            this._interp.UpdateObservationListDraftComment(this.additionalObservationList.Id, this.comment).subscribe(r => {
          if (r > 0) {
            this.successfulSaved('Saved', 'Additional Observation Comment Successfully Saved');
          }   else {
            this.errorSaved('Failed', 'Unable to save comment. Please contact TrackTreads support. ', r);
          }
        });
          }        
        break;
        case +CommentPopupRequestPageAndFunc.ObservationListCommentInterpretation:
        this._interp.UpdateInspectionObservationListComment(this.additionalObservationList.Id, this.comment).subscribe((r:any) => {
          if (r > 0) {
            this.successfulSaved('Saved', 'Additional Observation Comment Successfully Saved');
          }   else {
            this.errorSaved('Failed', 'Unable to save comment. Please contact TrackTreads support. ', r);
          }
        });
        break;
        case +CommentPopupRequestPageAndFunc.EquipmentDetailComment:
        this._interp.UpdateEquipmentComment(   this.equipmentId, this.comment).subscribe((r:any) => {
          if (r > 0) {
            this.successfulSaved('Saved', 'Additional Observation Comment Successfully Saved');
          }   else {
            this.errorSaved('Failed', 'Unable to save comment. Please contact TrackTreads support. ', r);
          }
        });
        break;
        case CommentPopupRequestPageAndFunc.ObservationCommentsInspection:
          this._notify.success('Saved', 'Additional Observation Comment Successfully Saved');
          this._dialogRef.close({ close: true, comment: this.comment });
      }
    } else
    if (!this.isEditingDraft) {
      this._interp.updateConditionComment(com).subscribe(r => {
        if (r.m_Item1) {
          this.successfulSaved('Saved', r.m_Item2);
        } else {
          this.errorSaved('Failed', r.m_Item2, r.m_Item2);
        }
      }, err => {
        this.errorSaved('Failed', 'Unable to save comment. Please contact TrackTreads support. ', err);
      });
    }  else {
      com.InspectionId = this.inspectionDraftId;
      com.EquipmentId = this.equipmentId;
      this._interp.updateInspectionDraftConditionComment(com).subscribe(r => {
        if (r.m_Item1) {
          this.successfulSaved('Saved', r.m_Item2);
        } else {
          this.errorSaved('Failed', r.m_Item2, r.m_Item2);
        }

      }, err => {
        this.errorSaved('Failed', 'Unable to save comment. Please contact TrackTreads support. ', err);
      });
    }

  }



  successfulSaved(title: string, message: string) {
    if( this.isEditingDraft==true && this.comingFrom==null){
      this._notify.success(title, "Comment saved successfully.");
      this._dialogRef.close(message);
      this.savingComment = false;
    }
    if(this.isCreateNewSP){
      this._notify.success(title, message);
      this._dialogRef.close({close: true, comment: this.comment});
      this.savingComment = false;
    }
    else{
      this._notify.success(title, message);
      this._dialogRef.close(true);
      this.savingComment = false;
    }
   
  }

  errorSaved(title: string, message: string, err: any) {
    if( this.isEditingDraft==true && this.comingFrom==null){
      this._notify.error(title, "Unable to save comment. Please contact TrackTreads support.");
      console.error(err);
      this.savingComment = false;
    }else{
      this._notify.error(title, message);
      console.error(err);
      this.savingComment = false;
    }
    
  }

  onNoClick(): void {
    this._dialogRef.close(false);
  }
  
}
